<template>
  <div class="cover" :class="{
    'box-radius': raduis,
    'box-shadow': shadow
  }">
    <img :src="cover">
  </div>  
</template>

<script>
import { STATIC_URL, IMAGE_APPEND } from '../libs/constant'

export default {
  props: {
    src: {
      type: String,
      required: true
    },
    raduis: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cover () {
      return STATIC_URL + this.src + IMAGE_APPEND
    }
  }
}
</script>

<style lang="less" scoped>
.cover {
  width: 150px;
  height: 200px;
  background: #eeeeee;
}
</style>
